export default __webpack_public_path__ + "static/home-hero-2376ca8025804bb14b6b8ec57ab6c0af.svg";